<template>
  <div v-if="show">
    <div v-if="!edit">
      School Name: {{ school_data.name }}<br/>
      Type: {{ formatType(school_data.school_type) }}<br/>
      <div v-if="school_data.major">
        Major: {{ school_data.major }}<br/>
      </div>
      <div v-if="school_data.minor">
        Minor: {{ school_data.minor }}<br/>
      </div>
      Status: {{ school_data.status.charAt(0).toUpperCase() + school_data.status.slice(1) }}
      <br/>
      Start Date: {{formatDate(school_data.start_date)}}
      <br/>
      Graduation Date: {{ formatDate(school_data.graduation_date) }}<br/>
    </div>
    <form @submit.prevent="createOrUpdate" v-if="edit">
      <div class="form-group">
        <input type="hidden" name="id" v-model="school_data.id">
        School name:
        <input class="form-control" type="text" name="name" id="name" v-model="school_data.name" required/><br/>
        Type:
        <select class="form-control" name="school_type" id="school_type" v-model="school_data.school_type" required>
          <option value="high_school">High School</option>
          <option value="college">College</option>
          <option value="technical">Technical</option>
          <option value="academy">Academy</option>
        </select><br/>
        <div v-if="school_data.school_type == 'college'">
          Major:
          <input class="form-control" type="text" name="major" id="major" v-model="school_data.major" required/><br/>
          Minor:
          <input class="form-control" type="text" name="minor" id="minor" v-model="school_data.minor"/><br/>
        </div>
        Status:
        <select class="form-control" name="status" id="status" v-model="school_data.status" required>
          <option value="enrolled">Currently Enrolled</option>
          <option value="intended">Intended</option>
          <option value="graduated">Graduated</option>
        </select><br/>
        Start date:
        <input class="form-control" type="date" name="start_date" id="start_date" v-model="school_data.start_date" required/><br/>
        Graduation date:
        <input class="form-control" type="date" name="graduation_date" id="graduation_date" v-model="school_data.graduation_date" required/><br/>
        <button class="btn btn-form better_font" type="submit">Update</button>
      </div>
    </form>
    <div v-if="!edit">
      <button class="btn btn-form better_font mr-1" @click="toggleEdit">Edit</button>
      <button class="btn btn-danger better_font" @click="deleteSchool(school_data.id)">Delete</button>
    </div>
    <hr/>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: "school",
  props:{
    school_data: Object
  },
  data(){
    return{
      errors: [],
      show: true,
      edit: true,
    }
  },
  mounted(){
    this.checkId()
  },
  methods:{
    checkId(){
      if(!this.school_data.id)
        this.edit = true
    },
    updateSchool(data){
      axios.put(
        `${process.env.VUE_APP_ENDPOINT}/api/applicant/profile/schools/` + data.school.id,
        data
      )
    },
    createSchool(data){
      axios.post(
        `${process.env.VUE_APP_ENDPOINT}/api/applicant/profile/schools/`,
        data
      )
    },
    deleteSchool(school_id){
      if(school_id)
        axios.delete(`${process.env.VUE_APP_ENDPOINT}/api/applicant/profile/schools/` + school_id)
      this.show = false
    },
    createOrUpdate(event){
      if(event.target[0].name == 'id' && event.target[0].value !== ''){
        this.updateSchool(this.dataFormatter(event.target))
      }else{
        this.createSchool(this.dataFormatter(event.target))
      }
      this.edit = false
    },
    dataFormatter(form_input_data){
      let ready = {school:{}}
      Array.from(form_input_data).forEach( el => {
        if(el.name)
          ready.school[el.name] = el.value
      })
      return ready
    },
    formatDate(date){
      return date.substr(5, 2) + '/' + date.substr(8, 2) + '/'+ date.substr(0, 4)
    },
    formatType(type){
      var upper = type.charAt(0).toUpperCase() + type.slice(1)
      return upper.replace("_s", " S")
    },
    toggleEdit(){
      this.edit = !this.edit
    }
  }
}
</script>

<style>

.btn-form {
  background-color: #27AAE1;
  color: white;
}

.btn-form:hover {
  background-color: #1B86B5;
}

</style>
